import { APICategorySeoInfo, APIRedirect } from '@/types'

export function isAPIRedirect(obj: unknown): obj is APIRedirect {
    return obj !== null && typeof obj === 'object' && 'redirectTarget' in obj && 'status' in obj
}

export function isValidAPICategorySeoInfo(obj: unknown): obj is APICategorySeoInfo {
    return obj !== null && typeof obj === 'object' && 'categoryType' in obj && typeof obj.categoryType === 'string'
}

export const HOMEPAGE_CATEGORIES_CACHE = 5 * 60 * 1000 // 5 min
export const MAIN_CATEGORIES_CACHE = 10 * 60 * 1000 // 10 min
